import {reducer as invoicesReducer, REDUCER_KEY as INVOICES_REDUCER_KEY} from './features/invoices'

export default {
  [INVOICES_REDUCER_KEY]: invoicesReducer,
}
